import {
  Box,
  Button,
  NumberInput,
  NumberInputField,
  Td,
  Tr
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { CompraTypeItem } from "models/compras_type";
import { NewProduct } from "models/new_product_type";
import { OptionType } from "models/select_mode";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface ICompraItemRow {
  item: CompraTypeItem;
  produtos: NewProduct[];
  showError: (title: string, msg: string) => void;
  deleteRow: (item: CompraTypeItem) => void;
  editRow: (item: CompraTypeItem) => void;
}

const CompraItemRow = ({
  item,
  produtos,
  showError,
  deleteRow,
  editRow,
}: ICompraItemRow) => {
  const onChangeInput = (item: CompraTypeItem, value: string, type: string) => {
    switch (type) {
      case "produto":
        const prd = produtos?.find((a) => a.id === value);
        if (prd) {
          item.novoProduto = prd;
          item.produtoNome = prd.nome;
          item.novoProdutoId = prd.id;
          item.valorUn = prd.precoVenda;
        }
        break;

      case "qtd":
        item.quantidade = Number(value);
        break;

      case "ipi":
        item.percentualIpi = value;
        item.valorIpi =
          item?.valorTotal - item?.quantidade * item?.novoProduto?.precoVenda;
        break;

      default:
        break;
    }
    calculaTotal();
  };

  const calculaTotal = () => {
    const calc = item.novoProduto?.precoVenda * item.quantidade;
    const itemTotal = (calc * Number(item.percentualIpi)) / 100 + calc;
    item.valorTotal = itemTotal;
    editRow(item);
  };

  return (
    <Tr>
      <Td>
        <Box w={300}>
          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            onChange={(e) => {
              onChangeInput(item, e.value, "produto");
            }}
            placeholder="Buscar..."
            isDisabled={false}
            name={"Produto"}
            options={produtos?.map((item) => {
              return {
                label: item?.nome,
                value: item?.id,
              };
            })}
            value={{
              label: item?.produtoNome,
              value: item.novoProdutoId,
            }}
          />
        </Box>
      </Td>
      <Td>{item?.novoProduto?.sku}</Td>
      <Td> {item?.produtoNome}</Td>
      <Td>
        <NumberInput
          precision={2}
          defaultValue={item?.quantidade}
          style={{
            width: 100,
          }}
          name={`quantidade--`}
          onBlur={(e) => {
            onChangeInput(item, e.target.value, "qtd");
          }}
        >
          <NumberInputField />
        </NumberInput>
      </Td>
      <Td>
        {isNaN(item?.novoProduto?.precoVenda)
          ? formatNumber(0)
          : formatNumber(Number(item?.novoProduto?.precoVenda))}
      </Td>
      <Td>
        <NumberInput
          precision={2}
          defaultValue={item?.percentualIpi}
          name={`IPI--`}
          style={{
            width: 100,
          }}
          onBlur={(e) => {
            onChangeInput(item, e.target.value, "ipi");
          }}
        >
          <NumberInputField />
        </NumberInput>
      </Td>
      <Td>{formatNumber(Number(item.valorTotal))}</Td>
      <Td>
        <Button
          onClick={() => {
            deleteRow(item);
          }}
          colorScheme="red"
          variant="ghost"
          ml="1"
        >
          Excluir
        </Button>
      </Td>
    </Tr>
  );
};

export default CompraItemRow;
